/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeliveryDriverDto } from '../models/DeliveryDriverDto';
import type { GetActiveMealClientResponse } from '../models/GetActiveMealClientResponse';
import type { GetAvailableMealsResponseDriver } from '../models/GetAvailableMealsResponseDriver';
import type { GetMealAddressesAdminResponse } from '../models/GetMealAddressesAdminResponse';
import type { GetMealBranchesAdminResponse } from '../models/GetMealBranchesAdminResponse';
import type { GetMealBranchesDriverResponse } from '../models/GetMealBranchesDriverResponse';
import type { GetMealItemsAdminResponse } from '../models/GetMealItemsAdminResponse';
import type { GetMealItemsClientResponse } from '../models/GetMealItemsClientResponse';
import type { GetMealItemsDriverResponse } from '../models/GetMealItemsDriverResponse';
import type { GetMealItemsOperatorResponse } from '../models/GetMealItemsOperatorResponse';
import type { GetMealsCountByStatusAdminResponse } from '../models/GetMealsCountByStatusAdminResponse';
import type { GetMealsMonitoringAdminResponse } from '../models/GetMealsMonitoringAdminResponse';
import type { GetMealsOperatorResponse } from '../models/GetMealsOperatorResponse';
import type { GetMealStatusCanBeUpdatedToResponseAdmin } from '../models/GetMealStatusCanBeUpdatedToResponseAdmin';
import type { GetMealStatusLogsAdminResponse } from '../models/GetMealStatusLogsAdminResponse';
import type { GetMealStreamsAdminResponse } from '../models/GetMealStreamsAdminResponse';
import type { GetMealStreamsV2ResponseAdmin } from '../models/GetMealStreamsV2ResponseAdmin';
import type { GetMealUsersAdminResponse } from '../models/GetMealUsersAdminResponse';
import type { GetMealUsersOperatorResponse } from '../models/GetMealUsersOperatorResponse';
import type { GetScheduledMyMealProgramPreviewAdminResponse } from '../models/GetScheduledMyMealProgramPreviewAdminResponse';
import type { MealAdminDto } from '../models/MealAdminDto';
import type { MealClientDto } from '../models/MealClientDto';
import type { MealDriverDto } from '../models/MealDriverDto';
import type { MealOperatorDto } from '../models/MealOperatorDto';
import type { MealStatus } from '../models/MealStatus';
import type { Pagination1OfMealClientDto } from '../models/Pagination1OfMealClientDto';
import type { Pagination1OfMealListedAdminDto } from '../models/Pagination1OfMealListedAdminDto';
import type { Pagination1OfMealOperatorListedDto } from '../models/Pagination1OfMealOperatorListedDto';
import type { PostAssignMealRequestAdmin } from '../models/PostAssignMealRequestAdmin';
import type { PostCancelMealAdminRequest } from '../models/PostCancelMealAdminRequest';
import type { PostMealAcquireAdminRequest } from '../models/PostMealAcquireAdminRequest';
import type { PostMealBranchAcceptAdminRequest } from '../models/PostMealBranchAcceptAdminRequest';
import type { PostMealBranchAcceptOperatorRequest } from '../models/PostMealBranchAcceptOperatorRequest';
import type { PostMealItemAdminRequest } from '../models/PostMealItemAdminRequest';
import type { PostMealItemClientRequest } from '../models/PostMealItemClientRequest';
import type { PostScheduledMyMealProgramAdminRequest } from '../models/PostScheduledMyMealProgramAdminRequest';
import type { PostScheduledMyMealProgramAdminResponse } from '../models/PostScheduledMyMealProgramAdminResponse';
import type { PostScheduledMyMealProgramPreviewAdminRequest } from '../models/PostScheduledMyMealProgramPreviewAdminRequest';
import type { PutMealDatesAdminRequest } from '../models/PutMealDatesAdminRequest';
import type { PutMealItemAdminRequest } from '../models/PutMealItemAdminRequest';
import type { ScheduledMyMealDailyOrderAdminDto } from '../models/ScheduledMyMealDailyOrderAdminDto';
import type { ScheduledMyMealDailyOrderAdminRequest } from '../models/ScheduledMyMealDailyOrderAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MealsService {
    /**
     * @returns MealOperatorDto OK
     * @throws ApiError
     */
    public static getMealOperator({
        id,
        branchId,
    }: {
        id: string,
        branchId?: number,
    }): CancelablePromise<MealOperatorDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/meals/{id}',
            path: {
                'id': id,
            },
            query: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetMealItemsOperatorResponse OK
     * @throws ApiError
     */
    public static getMealItemsOperator({
        id,
        branchId,
    }: {
        id: string,
        branchId?: number,
    }): CancelablePromise<GetMealItemsOperatorResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/meals/{id}/items',
            path: {
                'id': id,
            },
            query: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetMealUsersOperatorResponse OK
     * @throws ApiError
     */
    public static getMealUsersOperator({
        id,
        branchId,
    }: {
        id: string,
        branchId?: number,
    }): CancelablePromise<GetMealUsersOperatorResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/meals/{id}/users',
            path: {
                'id': id,
            },
            query: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postMealBranchAcceptOperator({
        mealBranchId,
        requestBody,
    }: {
        mealBranchId: string,
        requestBody?: PostMealBranchAcceptOperatorRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operator/v1/meals/branches/{mealBranchId}/accept',
            path: {
                'mealBranchId': mealBranchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postMealBranchPreparedOperator({
        mealBranchId,
    }: {
        mealBranchId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operator/v1/meals/branches/{mealBranchId}/prepared',
            path: {
                'mealBranchId': mealBranchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfMealOperatorListedDto OK
     * @throws ApiError
     */
    public static getMealsOperator({
        branchId,
        id,
        serviceId,
        statuses,
        companyId,
        fromDate,
        toDate,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        branchId?: number,
        id?: string,
        serviceId?: number,
        statuses?: Array<MealStatus>,
        companyId?: number,
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfMealOperatorListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/meals',
            query: {
                'branchId': branchId,
                'id': id,
                'serviceId': serviceId,
                'statuses': statuses,
                'companyId': companyId,
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetMealsOperatorResponse OK
     * @throws ApiError
     */
    public static getMealsMonitoringOperator({
        branchId,
        id,
        serviceId,
        statuses,
        companyId,
        fromDate,
        toDate,
    }: {
        branchId?: number,
        id?: string,
        serviceId?: number,
        statuses?: Array<MealStatus>,
        companyId?: number,
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetMealsOperatorResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/meals/monitoring',
            query: {
                'branchId': branchId,
                'id': id,
                'serviceId': serviceId,
                'statuses': statuses,
                'companyId': companyId,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetAvailableMealsResponseDriver OK
     * @throws ApiError
     */
    public static getAvailableMealsDriver(): CancelablePromise<GetAvailableMealsResponseDriver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/meals/available',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns DeliveryDriverDto OK
     * @throws ApiError
     */
    public static postMealAcquireDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<DeliveryDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/meals/{id}/acquire',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postMealDeclineDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/meals/{id}/decline',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetMealItemsDriverResponse OK
     * @throws ApiError
     */
    public static getMealItemsDriver({
        deliveryId,
        branchId,
    }: {
        deliveryId?: string,
        branchId?: number,
    }): CancelablePromise<GetMealItemsDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/meals/items',
            query: {
                'deliveryId': deliveryId,
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetMealBranchesDriverResponse OK
     * @throws ApiError
     */
    public static getMealBranchesDriver({
        deliveryId,
    }: {
        deliveryId?: string,
    }): CancelablePromise<GetMealBranchesDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/meals/branches',
            query: {
                'deliveryId': deliveryId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns MealDriverDto OK
     * @throws ApiError
     */
    public static postMealCollectingDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<MealDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/meals/{id}/collecting',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns MealDriverDto OK
     * @throws ApiError
     */
    public static postMealItemPickedUpDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<MealDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/meals/branches/{id}/picked-up',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns MealDriverDto OK
     * @throws ApiError
     */
    public static postMealBranchDriverReachedDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<MealDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/meals/branches/{id}/driver-reached-branch',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns MealDriverDto OK
     * @throws ApiError
     */
    public static postMealDeliveringDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<MealDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/meals/{id}/delivering',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns MealDriverDto OK
     * @throws ApiError
     */
    public static postMealAtDestinationDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<MealDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/meals/{id}/at-destination',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns MealDriverDto OK
     * @throws ApiError
     */
    public static postMealCompleteDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<MealDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/meals/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns MealClientDto OK
     * @throws ApiError
     */
    public static postMealItemsClient({
        requestBody,
    }: {
        requestBody?: PostMealItemClientRequest,
    }): CancelablePromise<MealClientDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/meals/items',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteMealItemsClient({
        mealItemId,
    }: {
        mealItemId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/client/v1/meals/items/{mealItemId}',
            path: {
                'mealItemId': mealItemId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetActiveMealClientResponse OK
     * @throws ApiError
     */
    public static getActiveMealsClient(): CancelablePromise<GetActiveMealClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/meals/actives',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetMealItemsClientResponse OK
     * @throws ApiError
     */
    public static getMealItemsClient({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetMealItemsClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/meals/{id}/items',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfMealClientDto OK
     * @throws ApiError
     */
    public static getMealsClient({
        fromDate,
        toDate,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfMealClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/meals',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns GetScheduledMyMealProgramPreviewAdminResponse OK
     * @throws ApiError
     */
    public static postScheduledProgramPreviewAdmin({
        requestBody,
    }: {
        requestBody?: PostScheduledMyMealProgramPreviewAdminRequest,
    }): CancelablePromise<GetScheduledMyMealProgramPreviewAdminResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/scheduled-programs/preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns PostScheduledMyMealProgramAdminResponse OK
     * @throws ApiError
     */
    public static postScheduledProgramAdmin({
        requestBody,
    }: {
        requestBody?: PostScheduledMyMealProgramAdminRequest,
    }): CancelablePromise<PostScheduledMyMealProgramAdminResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/scheduled-programs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCompanies`
     * @returns ScheduledMyMealDailyOrderAdminDto OK
     * @throws ApiError
     */
    public static getScheduledProgramsAdmin({
        companyId,
        fromDate,
        toDate,
    }: {
        companyId?: number,
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<Array<ScheduledMyMealDailyOrderAdminDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/scheduled-programs',
            query: {
                'companyId': companyId,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns ScheduledMyMealDailyOrderAdminDto OK
     * @throws ApiError
     */
    public static getScheduledProgramAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<ScheduledMyMealDailyOrderAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/scheduled-programs/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns ScheduledMyMealDailyOrderAdminDto OK
     * @throws ApiError
     */
    public static putScheduledProgramAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: ScheduledMyMealDailyOrderAdminRequest,
    }): CancelablePromise<ScheduledMyMealDailyOrderAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/meals/scheduled-programs/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postScheduledProgramCancelAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostCancelMealAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/scheduled-programs/{id}/cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCompanies`
     * @returns GetMealStreamsAdminResponse OK
     * @throws ApiError
     */
    public static getMealStreamsAdmin({
        regionIds,
        statuses,
        fetchAll,
        branchIds,
        userIds,
        fromDate,
        toDate,
    }: {
        regionIds: Array<number>,
        statuses: Array<MealStatus>,
        fetchAll?: boolean,
        branchIds?: Array<number>,
        userIds?: Array<string>,
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetMealStreamsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/streams',
            query: {
                'fetchAll': fetchAll,
                'regionIds': regionIds,
                'branchIds': branchIds,
                'userIds': userIds,
                'statuses': statuses,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCompanies`
     * @returns GetMealStreamsV2ResponseAdmin OK
     * @throws ApiError
     */
    public static getMealStreamsV2Admin({
        cursor,
        limit,
        statuses,
        regionIds,
        branchIds,
        userIds,
        fromDate,
        toDate,
        trackingPanelUserId,
        referenceCode,
    }: {
        cursor?: string,
        limit?: number,
        statuses?: Array<MealStatus>,
        regionIds?: Array<number>,
        branchIds?: Array<number>,
        userIds?: Array<string>,
        fromDate?: string,
        toDate?: string,
        trackingPanelUserId?: string,
        referenceCode?: string,
    }): CancelablePromise<GetMealStreamsV2ResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/streamsv2',
            query: {
                'cursor': cursor,
                'limit': limit,
                'statuses': statuses,
                'regionIds': regionIds,
                'branchIds': branchIds,
                'userIds': userIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'trackingPanelUserId': trackingPanelUserId,
                'referenceCode': referenceCode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCompanies`
     * @returns Pagination1OfMealListedAdminDto OK
     * @throws ApiError
     */
    public static getMealsAdmin({
        id,
        serviceId,
        statuses,
        companyId,
        branchId,
        userId,
        fromDate,
        toDate,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: string,
        serviceId?: number,
        statuses?: Array<MealStatus>,
        companyId?: number,
        branchId?: number,
        userId?: string,
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfMealListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals',
            query: {
                'id': id,
                'serviceId': serviceId,
                'statuses': statuses,
                'companyId': companyId,
                'branchId': branchId,
                'userId': userId,
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCompanies`
     * @returns GetMealsMonitoringAdminResponse OK
     * @throws ApiError
     */
    public static getMealsMonitoringAdmin({
        regionIds,
        statuses,
        fetchAll,
        fromDate,
        toDate,
    }: {
        regionIds: Array<number>,
        statuses: Array<MealStatus>,
        fetchAll?: boolean,
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetMealsMonitoringAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/monitoring',
            query: {
                'fetchAll': fetchAll,
                'regionIds': regionIds,
                'statuses': statuses,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns MealAdminDto OK
     * @throws ApiError
     */
    public static getMealAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<MealAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns GetMealStatusLogsAdminResponse OK
     * @throws ApiError
     */
    public static getMealStatusLogsAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetMealStatusLogsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/{id}/status-logs',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns GetMealItemsAdminResponse OK
     * @throws ApiError
     */
    public static getMealItemsAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetMealItemsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/{id}/items',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns GetMealAddressesAdminResponse OK
     * @throws ApiError
     */
    public static getMealAddressesAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetMealAddressesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/{id}/addresses',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns GetMealUsersAdminResponse OK
     * @throws ApiError
     */
    public static getMealUsersAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetMealUsersAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/{id}/users',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns GetMealBranchesAdminResponse OK
     * @throws ApiError
     */
    public static getMealBranchesAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetMealBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/{id}/branches',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealAcquireAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostMealAcquireAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/{id}/acquire',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealCollectingAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/{id}/collecting',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealDeliveringAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/{id}/delivering',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealAtDestinationAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/{id}/at-destination',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealCompleteAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealNotDeliveredAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/{id}/not-delivered',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealCancelAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostCancelMealAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/{id}/cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealBranchAcceptAdmin({
        mealBranchId,
        requestBody,
    }: {
        mealBranchId: string,
        requestBody?: PostMealBranchAcceptAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/branches/{mealBranchId}/accept',
            path: {
                'mealBranchId': mealBranchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealItemPreparedAdmin({
        mealBranchId,
    }: {
        mealBranchId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/branches/{mealBranchId}/prepared',
            path: {
                'mealBranchId': mealBranchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealBranchDriverReachedAdmin({
        mealBranchId,
    }: {
        mealBranchId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/branches/{mealBranchId}/driver-reached-branch',
            path: {
                'mealBranchId': mealBranchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealBranchPickedUpAdmin({
        mealBranchId,
    }: {
        mealBranchId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/branches/{mealBranchId}/picked-up',
            path: {
                'mealBranchId': mealBranchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns GetMealStatusCanBeUpdatedToResponseAdmin OK
     * @throws ApiError
     */
    public static getMealStatusCanBeUpdatedToAdmin({
        mealStatus,
    }: {
        mealStatus?: MealStatus,
    }): CancelablePromise<GetMealStatusCanBeUpdatedToResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/status-can-be-updated-to',
            query: {
                'mealStatus': mealStatus,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static putMealDatesAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutMealDatesAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/meals/{id}/dates',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postBroadcastDeliveryAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/{id}/broadcast',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealAssignAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostAssignMealRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/{id}/assign',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealUnassignAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/{id}/unassign',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMealItems`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealItemAdmin({
        requestBody,
    }: {
        requestBody?: PostMealItemAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/items',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMealItems`
     * @returns any OK
     * @throws ApiError
     */
    public static putMealItemAdmin({
        mealItemId,
        requestBody,
    }: {
        mealItemId: string,
        requestBody?: PutMealItemAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/meals/items/{mealItemId}',
            path: {
                'mealItemId': mealItemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMealItems`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteMealItemAdmin({
        mealItemId,
    }: {
        mealItemId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/meals/items/{mealItemId}',
            path: {
                'mealItemId': mealItemId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `WatchMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealTrackingAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/meals/{id}/tracking',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetMealsCountByStatusAdminResponse OK
     * @throws ApiError
     */
    public static getMealsCountByStatusAdmin({
        statuses,
        regionIds,
        fromDate,
        toDate,
    }: {
        statuses?: Array<MealStatus>,
        regionIds?: Array<number>,
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetMealsCountByStatusAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/meals/count-by-status',
            query: {
                'statuses': statuses,
                'regionIds': regionIds,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
